import {OrderDto} from '../../types'

import {getLifeCycleEvent} from './getLifeCycleEvent'
import {isProcessEvent, ProcessEvent} from './lifeCycle.types'

/**
 * Compares the order's current lifecycle event with a target event
 *
 * @param order - Order to evaluate
 * @param event - Target lifecycle event to compare against
 * @returns 'before' if order hasn't reached the event, 'after' if it has, 'not-applicable' if order is in non-process state
 */
export const compareLifeCycle = (order: OrderDto, event: ProcessEvent) => {
  const lastEvent = getLifeCycleEvent(order)

  if (!isProcessEvent(lastEvent)) {
    return 'not-applicable'
  }

  return lastEvent < event ? 'before' : 'after'
}
